import * as React from "react";
import PropTypes from "prop-types";
import { Typography, Skeleton } from "../../../themeV2";
import styles from "./Description.module.css";

const Description = React.memo(function Description({
  influencer,
  isLoading,
  isError,
  align = "center",
}) {
  if (isError) {
    return (
      <Typography variant="body-lg" as="p" color="error">
        Unable to load shop description
      </Typography>
    );
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.descriptionArea}>
        {isLoading && <Skeleton style={{ width: "100%", height: "1.5em" }} />}

        {!isLoading && influencer?.caption && (
          <Typography
            variant="body-lg"
            color="variant"
            align="center"
            as="p"
            className={[
              styles.description,
              align === "start" && styles.alignStart,
            ]
              .filter(Boolean)
              .join(" ")}
          >
            {influencer.caption}
          </Typography>
        )}
      </div>
    </div>
  );
});

Description.propTypes = {
  influencer: PropTypes.object,
  isLoading: PropTypes.bool,
  isError: PropTypes.bool,
  align: PropTypes.oneOf(["center", "start"]),
};

export default Description;
